<!--
 * @Author       : panyangyang
 * @Date         : 2026-02-05 09:20:06
 * @LastEditTime : 2026-02-10 10:11:51
 * @LastEditors  : panyangyang
 * @Description  : 新增供应商弹框
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\supplier-list\components\add-supplier-dialog.vue
-->
<template>
	<div>
		<el-dialog
			:title="dialogObj.title"
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:close-on-click-modal="false"
			class="primary-dialog"
			append-to-body
			@closed="closeDialog"
		>
			<div>
				<Panel :expand="true" title="#1 基本信息">
					<el-form ref="supplierForm" :model="supplierForm" label-width="150px" :show-message="false">
						<el-form-item label="供应商名称" prop="sname" :rules="requiredRule">
							<el-input
								v-model="supplierForm.sname"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="统一社会信用代码" prop="taxNo" :rules="requiredRule">
							<el-input
								v-model="supplierForm.taxNo"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="法定代表人" prop="legal">
							<el-input
								v-model="supplierForm.legal"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="住所" prop="abode">
							<el-input
								v-model="supplierForm.abode"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="经营范围" prop="busScope">
							<el-input
								v-model="supplierForm.busScope"
								type="textarea"
								maxlength="200"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="营业执照">
							<div class="w200">
								<new-upload
									ref="upload"
									listType="picture-card"
									tableName="tem_supplier"
									assortment="supplier_file"
									:aid="supplierForm.id"
									:lazyTime="1000"
									:acceptType="['png', 'jpeg', 'jpg', 'bmp']"
									:maxNum="1"
									:multiple="false"
									:isDisabled="dialogObj.mode == 'view'"
								></new-upload>
							</div>
						</el-form-item>
					</el-form>
				</Panel>
				<Panel :expand="true" title="#2 账户信息">
					<el-form ref="accountForm" :model="supplierForm" label-width="150px" :show-message="false">
						<el-form-item label="收款账户名" prop="collectAccount" :rules="requiredRule">
							<el-input
								v-model="supplierForm.collectAccount"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="收款账号" prop="collectNo" :rules="[...requiredRule, ...numberRule]">
							<el-input
								v-model="supplierForm.collectNo"
								maxlength="19"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="收款开户行" prop="collectBank" :rules="requiredRule">
							<el-input
								v-model="supplierForm.collectBank"
								maxlength="50"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="联系人" prop="collectLink" :rules="requiredRule">
							<el-input
								v-model="supplierForm.collectLink"
								maxlength="20"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
						<el-form-item label="联系电话" prop="collectPhone" :rules="requiredRule">
							<el-input
								v-model="supplierForm.collectPhone"
								maxlength="20"
								show-word-limit
								placeholder="请输入"
								:disabled="dialogObj.mode === 'view'"
							></el-input>
						</el-form-item>
					</el-form>
				</Panel>
				<Panel :expand="true" title="#3 关联商品信息" v-if="dialogObj.mode !== 'add'">
					<vxe-table
						ref="xTable"
						:data="tableObj.tableData"
						align="center"
						border
						maxHeight="400px"
						size="small"
						auto-resize
						resizable
						show-overflow="tooltip"
						show-header-overflow="tooltip"
					>
						<vxe-table-column type="seq" title="序号" width="60px"></vxe-table-column>
						<vxe-table-column field="goodsName" title="商品名称" min-width="150px"></vxe-table-column>
						<vxe-table-column field="relateTime" title="关联时间" min-width="150px"> </vxe-table-column>
						<vxe-table-column field="goodsStatus" title="商品状态" width="150px"></vxe-table-column>
					</vxe-table>
					<div class="text-center mt20">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableObj.currentPage"
							:page-size="tableObj.pageSize"
							:page-sizes="[10, 20, 50, 100]"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableObj.total"
						>
						</el-pagination>
					</div>
				</Panel>
				<Panel :expand="true" :title="`#${dialogObj.mode === 'add' ? '3' : '4'} 供应商状态信息`">
					<el-form ref="statusForm" :model="supplierForm" label-width="150px" :show-message="false">
						<el-form-item label="供应商状态" prop="status" :rules="requiredRule">
							<el-select v-model="supplierForm.status" placeholder="请选择" clearable :disabled="dialogObj.mode === 'view'">
								<el-option value="0" label="暂停合作"></el-option>
								<el-option value="1" label="正常"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</Panel>
			</div>
			<div slot="footer" class="text-center">
				<el-button size="small" class="btn" @click="closeDialog">取 消</el-button>
				<el-button
					v-if="dialogObj.mode !== 'view'"
					type="primary"
					size="small"
					class="btn btn-blue"
					:loading="dialogObj.btnLoading"
					@click="submitDialog"
					>保 存</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Panel from 'components/panel/Panel'
import newUpload from '@/views/operation-management/commodity-management/product-list/components/w-upload/newUpload.vue'
import * as Api from '@/api/modules/supplierList.js'

export default {
	props: {
		showSupplierDialog: {
			type: Boolean,
			default: false
		}
	},
	components: { Panel, newUpload },
	data() {
		return {
			// 弹框
			dialogObj: {
				title: '',
				visible: false,
				width: '800px',
				mode: '',
				btnLoading: false
			},
			rowObj: {}, // 列表行数据
			// 供应商表单
			supplierForm: {
				id: '',
				sname: '', // 供应商名称
				taxNo: '', // 统一社会信用代码
				legal: '', // 法定代表人
				abode: '', // 住所
				busScope: '', // 经营范围
				collectAccount: '', // 收款账户名
				collectNo: '', // 收款账号
				collectBank: '', // 收款开户行
				collectLink: '', // 联系人
				collectPhone: '', // 联系电话
				status: '' // 供应商状态
			},
			requiredRule: [{ required: true, trigger: ['blur', 'change'] }],
			moneyRule: [{ pattern: /(^[\d]|^[1-9][\d]{0,12})($|[\.][\d]{0,4}$)/ }],
			numberRule: [{ pattern: /^\d+$/, trigger: ['blur', 'change'] }],
			// 表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0
			}
		}
	},
	methods: {
		// 打开弹框
		open(type, data = {}) {
			this.dialogObj.mode = type
			this.dialogObj.visible = true
			this.dialogObj.title = type === 'add' ? '新增供应商' : type === 'edit' ? '编辑供应商' : '查看供应商'
			this.rowObj = this.$utils.clone(data, true)
			this.supplierForm.id = data.id || this.$SnowFlake.nextId()
			switch (type) {
				case 'add':
					break
				case 'edit':
				case 'view':
					this.getDetail()
					this.getTableData()
					break
				default:
					break
			}
		},

		// 获取详情
		getDetail() {
			Api.getSuppliersDetail({ id: this.rowObj.id }).then((res) => {
				Object.keys(this.supplierForm).map((i) => {
					this.supplierForm[i] = res.data[i] === null || res.data[i] === undefined ? '' : res.data[i]
				})
				this.supplierForm.status = String(res.data.status)
			})
		},

		// 获取表格数据
		getTableData() {
			const params = {
				id: this.rowObj.id,
				current: this.tableObj.currentPage,
				size: this.tableObj.pageSize
			}
			Api.getRelateGoodsPage(params).then((res) => {
				this.tableObj.tableData = res.data.records
				this.tableObj.total = Number(res.data.total)
			})
		},

		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.getTableData()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTableData()
		},

		// 关闭弹框
		closeDialog() {
			this.dialogObj.visible = false
			this.dialogObj.title = ''
			this.dialogObj.mode = ''
			this.$emit('update:showSupplierDialog', false)
			this.supplierForm = {
				id: '',
				sname: '', // 供应商名称
				taxNo: '', // 统一社会信用代码
				legal: '', // 法定代表人
				abode: '', // 住所
				busScope: '', // 经营范围
				collectAccount: '', // 收款账户名
				collectNo: '', // 收款账号
				collectBank: '', // 收款开户行
				collectLink: '', // 联系人
				collectPhone: '', // 联系电话
				status: '' // 供应商状态
			}
		},

		// 校验表单
		validForm(form) {
			return new Promise((resolve, reject) => {
				if (!form) {
					resolve() // 表单不存在
				} else {
					this.$refs[form].validate((valid) => {
						!valid ? reject() : resolve()
					})
				}
			})
		},

		// 提交弹框
		submitDialog() {
			const params = {
				// createUserid: this.userInfo.id,
				// createUser: this.userInfo.sname,
				...this.supplierForm
			}
			Promise.all([this.validForm('supplierForm'), this.validForm('accountForm'), this.validForm('statusForm')])
				.then((res) => {
					try {
						this.dialogObj.btnLoading = true
						Api.saveSuppliers(params)
							.then((res) => {
								if (res.operationCode == 1) {
									this.$message.success('保存成功！')
									this.$emit('doSuccess', this.dialogObj.type)
									this.closeDialog()
								}
								this.dialogObj.btnLoading = false
							})
							.catch(() => {
								this.dialogObj.btnLoading = false
							})
					} catch (error) {
						this.$message.warning('有必填项未填，请填写')
					}
				})
				.catch(() => {
					this.$message.warning('有必填项未填，请填写')
				})
		}
	},
	computed: {}
}
</script>

<style lang="less" scoped>
.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px 30px;
		max-height: 650px;
	}
	.w200 {
		width: 200px;
	}
}
</style>
